<template>
  <div v-if="produtosOp && aberta" class="d-inline-block">
    <button
      type="button"
      class="btn btn-depth btn-outline-secondary btn-sm mr-1"
      @click="abrir"
    >
      <i class="fas fa-search mr-1"></i>
      Buscar Equipamentos
    </button>
    <Modal
      modalId="modalBuscarEquipamentosOportunidade"
      title="Pesquisa de Equipamentos"
      dialogClass="modal-xl"
      myClass="modal-buscar-equipamentos"
    >
      <template #body>
        <div :key="painelKey" class="buscar-equipamentos__painel">
          <div v-if="loadingFiltros" class="text-muted py-4 text-center">
            <i class="fas fa-spinner fa-spin mr-1"></i>
            Carregando filtros...
          </div>

          <div v-else>
            <div v-if="filtros.length" class="buscar-equipamentos__filtros mb-3">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="buscar-equipamentos__filtros-title">Filtros</span>
              </div>
              <div class="row">
                <div
                  v-for="campo in filtros"
                  :key="campo.campos_recnum"
                  class="col-md-4 col-sm-6 mb-2"
                >
                  <label class="small mb-1">{{ campo.nome }}</label>
                  <div
                    class="buscar-equipamentos__multiselect"
                    :class="{
                      'buscar-equipamentos__multiselect--disabled': buscando || processando,
                    }"
                  >
                    <span
                      v-for="valor in selecaoFiltros[campo.campos_recnum] || []"
                      :key="valor"
                      class="badge badge-primary buscar-equipamentos__chip"
                      :title="valor"
                    >
                      {{ valor }}
                      <button
                        type="button"
                        class="buscar-equipamentos__chip-remove"
                        :disabled="buscando || processando"
                        @click="removerFiltro(campo.campos_recnum, valor)"
                        :title="'Remover ' + valor"
                      >
                        &times;
                      </button>
                    </span>
                    <select
                      class="buscar-equipamentos__multiselect-select"
                      :value="''"
                      :disabled="buscando || processando"
                      @change="adicionarFiltro(campo.campos_recnum, $event)"
                    >
                      <option value="" disabled>Selecionar</option>
                      <option
                        v-for="opcao in opcoesFiltroDisponiveis(campo)"
                        :key="opcao"
                        :value="opcao"
                      >
                        {{ opcao }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-2 d-flex align-items-end">
                  <button
                    type="button"
                    class="btn btn-depth btn-primary btn-sm w-100"
                    @click="buscar"
                    :disabled="buscando || processando"
                  >
                    <i class="fas fa-filter mr-1"></i>
                    {{ buscando ? 'Filtrando...' : 'Filtrar' }}
                  </button>
                </div>
              </div>
            </div>

            <div v-else class="mb-3">
              <button
                type="button"
                class="btn btn-depth btn-primary btn-sm"
                @click="buscar"
                :disabled="buscando || processando"
              >
                <i class="fas fa-filter mr-1"></i>
                {{ buscando ? 'Carregando...' : 'Carregar equipamentos' }}
              </button>
            </div>

            <div :key="resultadoKey" class="buscar-equipamentos__resultados">
              <div v-show="buscando" class="text-muted py-3 text-center">
                <i class="fas fa-spinner fa-spin mr-1"></i>
                Buscando equipamentos...
              </div>

              <div v-show="!buscando">
                <div v-if="linhasResultado.length" class="mb-2">
                  <input
                    type="search"
                    class="form-control form-control-sm"
                    v-model="pesquisaLista"
                    placeholder="Pesquisar por equipamento, SKU, código ERP, descrição..."
                    :disabled="processando"
                  />
                </div>

                <div
                  v-if="linhasFiltradas.length"
                  class="table-responsive buscar-equipamentos__tabela"
                >
                  <table class="table table-sm table-hover mb-0">
                    <thead>
                      <tr>
                        <th class="buscar-equipamentos__th-check">
                          <input
                            type="checkbox"
                            :checked="todosSelecionados"
                            @change="toggleTodos"
                            :disabled="processando"
                            title="Selecionar todos"
                          />
                        </th>
                        <th>Código do ERP</th>
                        <th>Descrição</th>
                        <th>Equipamento</th>
                        <th>Convergência | Divergência</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="linha in linhasFiltradas" :key="linha.key">
                        <td>
                          <input
                            type="checkbox"
                            :value="linha.key"
                            v-model="selecionados"
                            :disabled="processando"
                          />
                        </td>
                        <td>{{ linha.produto_codigo }}</td>
                        <td>{{ linha.produto_descricao }}</td>
                        <td>{{ linha.equipamento_label }}</td>
                        <td>
                          <span
                            v-for="campo in linha.campos_ok"
                            :key="'ok-' + campo.campos_recnum"
                            class="badge badge-success buscar-equipamentos__correspondencia mr-1 mb-1"
                            title="Campo correspondeu ao filtro"
                          >
                            {{ campo.nome }}
                          </span>
                          <span
                            v-for="campo in linha.campos_divergentes"
                            :key="'div-' + campo.campos_recnum"
                            class="badge badge-danger buscar-equipamentos__divergencia mr-1 mb-1"
                            :title="tituloDivergencia(campo)"
                          >
                            {{ campo.nome }}
                          </span>
                          <span
                            v-if="!linha.campos_ok.length && !linha.campos_divergentes.length"
                            class="text-muted small"
                          >
                            —
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  v-else-if="buscaRealizada && linhasResultado.length"
                  class="text-muted py-3 text-center buscar-equipamentos__vazio"
                >
                  Nenhum equipamento corresponde à pesquisa.
                </div>

                <div
                  v-else-if="buscaRealizada"
                  class="text-muted py-3 text-center buscar-equipamentos__vazio"
                >
                  Nenhum equipamento encontrado com os filtros informados.
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <span class="mr-auto text-muted small align-self-center">
          <template v-if="selecionados.length">
            {{ selecionados.length }} selecionado(s)
          </template>
        </span>
        <button
          type="button"
          class="btn btn-depth btn-secondary btn-sm"
          :disabled="processando"
          @click="fecharModal"
        >
          Fechar
        </button>
        <button
          type="button"
          class="btn btn-depth btn-primary btn-sm ml-2"
          @click="processarSelecionados"
          :disabled="!selecionados.length || processando"
        >
          {{ processando ? 'Processando...' : 'Processar Selecionados' }}
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import api, { api_erp } from '../../../api';
import Modal from '../ui/Modal.vue';

export default {
  name: 'ModalCamposEquipamentoOportunidade',
  components: {
    Modal,
  },
  props: {
    tokenErp: {
      type: String,
      default: '',
    },
    oportunidadeId: {
      type: [Number, String],
      default: null,
    },
    produtosOp: {
      type: Boolean,
      default: false,
    },
    aberta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtros: [],
      selecaoFiltros: {},
      resultados: [],
      selecionados: [],
      loadingFiltros: false,
      buscando: false,
      processando: false,
      buscaRealizada: false,
      painelKey: 0,
      resultadoKey: 0,
      pesquisaLista: '',
    };
  },
  computed: {
    linhasResultado() {
      const linhas = [];
      this.resultados.forEach((item) => {
        const equipamentos = Array.isArray(item.equipamentos)
          ? item.equipamentos
          : [];
        equipamentos.forEach((equip) => {
          const codigo = (equip.codigo || '').trim();
          let label = codigo;
          if (equip.terceiros) {
            label += ' (Terceiros)';
          }
          const campos = Array.isArray(equip.campos) ? equip.campos : [];
          const camposOk = this.nomesCamposPorRecnums(equip.campos_ok);
          const equipLocal = equip.local !== undefined && equip.local !== null
            ? equip.local
            : '';
          linhas.push({
            key: item.produto_codigo + '|' + codigo + '|' + equipLocal,
            produto_codigo: item.produto_codigo,
            produto_descricao: item.produto_descricao,
            equipamento_codigo: codigo,
            equipamento_label: label,
            equip_local: equipLocal,
            campos: campos,
            campos_ok: camposOk,
            campos_divergentes: Array.isArray(equip.campos_divergentes)
              ? equip.campos_divergentes
              : [],
            textoBusca: [
              item.produto_codigo,
              item.produto_descricao,
              label,
              codigo,
              campos
                .map((campo) => (campo.nome || '') + ' ' + (campo.valor || ''))
                .join(' '),
              camposOk.map((campo) => campo.nome || '').join(' '),
            ]
              .join(' ')
              .toLowerCase(),
          });
        });
      });
      return linhas;
    },
    linhasFiltradas() {
      const termo = String(this.pesquisaLista || '')
        .trim()
        .toLowerCase();
      if (!termo) {
        return this.linhasResultado;
      }
      return this.linhasResultado.filter((linha) => {
        return linha.textoBusca.indexOf(termo) !== -1;
      });
    },
    todosSelecionados() {
      return (
        this.linhasFiltradas.length > 0 &&
        this.linhasFiltradas.every((linha) => {
          return this.selecionados.indexOf(linha.key) !== -1;
        })
      );
    },
  },
  methods: {
    montarOpcoesItems(opcoes) {
      const lista = Array.isArray(opcoes) ? opcoes : [];
      return lista
        .map((opcao) => String(opcao).trim())
        .filter((opcao) => opcao !== '');
    },
    filtroJaSelecionado(camposRecnum, opcao) {
      const selecionados = this.selecaoFiltros[camposRecnum] || [];
      return selecionados.indexOf(opcao) !== -1;
    },
    opcoesFiltroDisponiveis(campo) {
      const selecionados = this.selecaoFiltros[campo.campos_recnum] || [];
      return (campo.opcoesItems || []).filter((opcao) => selecionados.indexOf(opcao) === -1);
    },
    adicionarFiltro(camposRecnum, event) {
      const valor = String((event.target && event.target.value) || '').trim();
      event.target.value = '';
      if (!valor || this.filtroJaSelecionado(camposRecnum, valor)) {
        return;
      }
      const atuais = this.selecaoFiltros[camposRecnum] || [];
      this.$set(this.selecaoFiltros, camposRecnum, atuais.concat([valor]));
    },
    removerFiltro(camposRecnum, valor) {
      const atuais = this.selecaoFiltros[camposRecnum] || [];
      this.$set(
        this.selecaoFiltros,
        camposRecnum,
        atuais.filter((item) => item !== valor)
      );
    },
    erpConfig(extra = {}) {
      return {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.tokenErp,
        },
        params: { ...extra },
      };
    },
    async abrir() {
      if (!this.tokenErp) {
        window.showToastDanger('body', 'Usuário sem autorização no ERP.');
        return;
      }

      this.resultados = [];
      this.selecionados = [];
      this.buscaRealizada = false;
      this.pesquisaLista = '';
      this.selecaoFiltros = {};
      this.filtros = [];
      this.loadingFiltros = true;
      this.painelKey += 1;

      // Carrega antes de abrir para evitar insertBefore com a modal Bootstrap animando.
      await this.carregarFiltros();
      await this.$nextTick();
      $('#modalBuscarEquipamentosOportunidade').modal('show');
    },
    fecharModal() {
      const modal = document.getElementById('modalBuscarEquipamentosOportunidade');
      const ativo = document.activeElement;
      if (modal && ativo && modal.contains(ativo) && typeof ativo.blur === 'function') {
        ativo.blur();
      }
      $('#modalBuscarEquipamentosOportunidade').modal('hide');
    },
    tituloDivergencia(campo) {
      const valor = campo.valor || '(vazio)';
      const filtros = Array.isArray(campo.filtros) ? campo.filtros.join(', ') : '';
      return 'Valor: ' + valor + (filtros ? ' | Filtro: ' + filtros : '');
    },
    nomesCamposPorRecnums(recnums) {
      const lista = Array.isArray(recnums) ? recnums : [];
      const mapa = {};
      this.filtros.forEach((campo) => {
        mapa[campo.campos_recnum] = campo.nome;
      });
      return lista.map((recnum) => {
        return {
          campos_recnum: recnum,
          nome: mapa[recnum] || String(recnum),
        };
      });
    },
    async carregarFiltros() {
      this.loadingFiltros = true;
      try {
        const response = await api_erp.get(
          '/app/equipamentos/alternativos/filtros',
          this.erpConfig()
        );
        const filtros = response.data?.data || [];
        const selecao = {};
        const mapeados = filtros.map((campo) => {
          selecao[campo.campos_recnum] = [];
          return Object.assign({}, campo, {
            opcoesItems: this.montarOpcoesItems(campo.opcoes),
          });
        });
        this.selecaoFiltros = selecao;
        this.filtros = mapeados;
        this.painelKey += 1;
      } catch (error) {
        this.filtros = [];
        window.showToastDanger('body', 'Erro ao carregar filtros de equipamentos.');
      } finally {
        this.loadingFiltros = false;
      }
    },
    montarFiltrosPayload() {
      const filtros = {};
      Object.keys(this.selecaoFiltros).forEach((recnum) => {
        const valores = (this.selecaoFiltros[recnum] || [])
          .map((item) => String(item || '').trim())
          .filter((valor) => valor !== '');
        if (valores.length) {
          filtros[recnum] = valores;
        }
      });
      return filtros;
    },
    async buscar() {
      this.buscando = true;
      this.buscaRealizada = true;
      this.resultados = [];
      this.selecionados = [];
      this.pesquisaLista = '';
      this.resultadoKey += 1;
      try {
        const response = await api_erp.post(
          '/app/equipamentos/alternativos/buscar',
          { filtros: this.montarFiltrosPayload() },
          Object.assign({}, this.erpConfig(), { timeout: 60000 })
        );
        this.resultados = response.data?.data || [];
        this.selecionados = [];
        this.resultadoKey += 1;
        await this.$nextTick();
      } catch (error) {
        this.resultados = [];
        this.selecionados = [];
        this.resultadoKey += 1;
        await this.$nextTick();
        const timedOut = error.code === 'ECONNABORTED';
        window.showToastDanger(
          'body',
          timedOut
            ? 'Tempo esgotado ao buscar equipamentos. Tente com menos filtros.'
            : 'Erro ao buscar equipamentos.'
        );
      } finally {
        this.buscando = false;
      }
    },
    toggleTodos(event) {
      if (event.target.checked) {
        const keys = this.linhasFiltradas.map((linha) => linha.key);
        const mapa = {};
        this.selecionados.forEach((key) => {
          mapa[key] = true;
        });
        keys.forEach((key) => {
          mapa[key] = true;
        });
        this.selecionados = Object.keys(mapa);
        return;
      }
      const remover = {};
      this.linhasFiltradas.forEach((linha) => {
        remover[linha.key] = true;
      });
      this.selecionados = this.selecionados.filter((key) => !remover[key]);
    },
    linhasSelecionadas() {
      return this.linhasResultado.filter((linha) => {
        return this.selecionados.indexOf(linha.key) !== -1;
      });
    },
    skusSelecionados() {
      const mapa = {};
      this.linhasSelecionadas().forEach((linha) => {
        mapa[linha.produto_codigo] = true;
      });
      return Object.keys(mapa);
    },
    snapshotLinhasSelecionadas() {
      return this.linhasSelecionadas().map((linha) => {
        return {
          produto_codigo: linha.produto_codigo,
          equipamento_codigo: linha.equipamento_codigo,
          equipamento_label: linha.equipamento_label,
          equip_local: linha.equip_local,
          campos: Array.isArray(linha.campos)
            ? linha.campos.map((campo) => {
                return {
                  nome: campo.nome,
                  valor: campo.valor,
                };
              })
            : [],
        };
      });
    },
    normalizarCamposApi(campos) {
      const lista = Array.isArray(campos) ? campos : [];
      return lista.map((campo) => {
        return {
          codigo: campo.codigo !== undefined && campo.codigo !== null ? campo.codigo : null,
          nome: campo.nome || '',
          valor:
            campo.valor !== undefined && campo.valor !== null
              ? String(campo.valor)
              : '',
          observacao: campo.observacao || campo.valores || '',
        };
      });
    },
    async buscarCamposAlternativosApi(linha) {
      const codigo = linha.equipamento_codigo;
      if (!codigo) {
        return [];
      }

      const local =
        linha.equip_local !== undefined &&
        linha.equip_local !== null &&
        String(linha.equip_local) !== ''
          ? linha.equip_local
          : 0;

      try {
        const response = await api_erp.get(
          '/app/equipamentos/' + encodeURIComponent(codigo) + '/campos-alternativos',
          this.erpConfig({ local: local })
        );
        return this.normalizarCamposApi(response.data?.data?.campos);
      } catch (error) {
        return [];
      }
    },
    async enriquecerLinhasComCampos(linhas) {
      const enriquecidas = [];
      for (let i = 0; i < linhas.length; i++) {
        const linha = linhas[i];
        let campos = await this.buscarCamposAlternativosApi(linha);
        if (!campos.length && Array.isArray(linha.campos) && linha.campos.length) {
          campos = this.normalizarCamposApi(linha.campos);
        }
        enriquecidas.push({
          produto_codigo: linha.produto_codigo,
          equipamento_codigo: linha.equipamento_codigo,
          equipamento_label: linha.equipamento_label,
          equip_local: linha.equip_local,
          campos: campos,
        });
      }
      return enriquecidas;
    },
    rotuloLinhaProcessar(sku, equipamentoCodigo) {
      const codigo = String(sku || '').trim() || 'SKU';
      const serie = String(equipamentoCodigo || '').trim();
      if (!serie) {
        return codigo;
      }
      return codigo + ' / série ' + serie;
    },
    async processarSelecionados() {
      if (!this.oportunidadeId) {
        window.showToastDanger('body', 'Oportunidade não informada.');
        return;
      }

      const linhasSnapshot = this.snapshotLinhasSelecionadas();
      if (!linhasSnapshot.length) {
        return;
      }

      this.processando = true;
      let adicionados = 0;

      try {
        const linhasComCampos = await this.enriquecerLinhasComCampos(linhasSnapshot);

        for (const linha of linhasComCampos) {
          const sku = linha.produto_codigo;
          try {
            const response = await api.post('/painel/oportunidades/adicionar-produto', {
              sku: sku,
              oportunidade_id: this.oportunidadeId,
              quantidade: 1,
              equipamento_codigo: linha.equipamento_codigo || null,
              equipamento_local:
                linha.equip_local !== undefined && linha.equip_local !== ''
                  ? linha.equip_local
                  : null,
              campos_alternativos: (linha.campos || []).map((campo) => {
                return {
                  codigo: campo.codigo || null,
                  nome: campo.nome || '',
                  valor: campo.valor || '',
                  observacao: campo.observacao || '',
                };
              }),
            });

            if (response.data?.error) {
              window.showToastDanger(
                'body',
                this.rotuloLinhaProcessar(sku, linha.equipamento_codigo) +
                  ': ' +
                  (response.data.message || 'Erro ao adicionar.')
              );
              continue;
            }

            adicionados++;
            if (response.data?.html) {
              for (const item of response.data.html) {
                $('.js-tabela-produtos tbody').append(item.view);
                if (window.Eloca && typeof window.Eloca.load === 'function') {
                  window.Eloca.load($('#tr-item-' + item.id));
                }
                if (typeof window.atualizarTotalTabela === 'function') {
                  window.atualizarTotalTabela('#tr-item-' + item.id);
                }
              }
            }
          } catch (error) {
            const message =
              error.response?.data?.message ||
              'SKU não encontrado no CRM ou erro ao adicionar.';
            window.showToastDanger(
              'body',
              this.rotuloLinhaProcessar(sku, linha.equipamento_codigo) +
                ': ' +
                message
            );
          }
        }

        if (adicionados > 0) {
          window.showToastSuccess(
            'body',
            adicionados + ' equipamento(s) adicionado(s) ao orçamento.'
          );
          if (typeof window.elocaSincronizarBotoesOrcamentoPorProdutos === 'function') {
            window.elocaSincronizarBotoesOrcamentoPorProdutos();
          }
          this.fecharModal();
        }
      } finally {
        this.processando = false;
      }
    },
  },
};
</script>

<style scoped>
.buscar-equipamentos__filtros {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.35rem;
  padding: 0.85rem 1rem 0.5rem;
}

.buscar-equipamentos__filtros-title {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6c757d;
}

.buscar-equipamentos__tabela {
  border: 1px solid #e9ecef;
  border-radius: 0.35rem;
  max-height: 420px;
  overflow: auto;
}

.buscar-equipamentos__tabela thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f1f3f5;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.buscar-equipamentos__tabela tbody td {
  font-size: 0.875rem;
  vertical-align: middle;
}

.buscar-equipamentos__th-check {
  width: 40px;
}

.buscar-equipamentos__vazio {
  border: 1px dashed #dee2e6;
  border-radius: 0.35rem;
  background: #fafbfc;
}

.buscar-equipamentos__multiselect {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  min-height: calc(2rem + 2px);
  padding: 0.25rem 0.35rem 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  background-color: #fff;
}

.buscar-equipamentos__multiselect--disabled {
  background-color: #e9ecef;
}

.buscar-equipamentos__multiselect-select {
  flex: 1 1 7rem;
  min-width: 7rem;
  width: auto;
  max-width: 100%;
  border: 0;
  background: transparent;
  padding: 0.125rem 1.25rem 0.125rem 0.25rem;
  height: calc(1.5em + 0.25rem);
  font-size: 0.875rem;
  line-height: 1.5;
  color: #495057;
  box-shadow: none;
  outline: none;
  cursor: pointer;
}

.buscar-equipamentos__multiselect-select:disabled {
  cursor: not-allowed;
  color: #6c757d;
}

.buscar-equipamentos__multiselect-select:focus {
  outline: none;
}

.buscar-equipamentos__chip {
  display: inline-flex;
  align-items: center;
  flex: 0 1 auto;
  max-width: 100%;
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0.2rem 0.35rem 0.2rem 0.5rem;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  line-height: 1.25;
}

.buscar-equipamentos__divergencia,
.buscar-equipamentos__correspondencia {
  font-weight: 500;
  white-space: nowrap;
}

.buscar-equipamentos__chip-remove {
  border: 0;
  background: transparent;
  color: inherit;
  margin-left: 0.25rem;
  line-height: 1;
  padding: 0;
  font-size: 1rem;
  cursor: pointer;
  opacity: 0.85;
}

.buscar-equipamentos__chip-remove:hover {
  opacity: 1;
}
</style>
